import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { copyToClipboardWithConfirmation } from '@openx/utils/lib/copyToClipboard.ts';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import type { InvalidItemsError } from '../../types.ts';

const StyledErrorsContainerDiv = styled('div')`
  padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

const StyledErrorTitleTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.main};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
`;

const StyledInvalidItemsTypography = styled(Typography)`
  border: 1px solid ${({ theme }) => theme.palette.error.main};
  height: 88px;
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  overflow-y: scroll;
  padding: ${({ theme }) => theme.spacing(0.25, 1.5)};
  background: ${({ theme }) => theme.palette.background.boxLight};
` as typeof Typography;

interface ErrorDetailsProps {
  errors: InvalidItemsError[];
}

export function ErrorDetails({ errors }: ErrorDetailsProps) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <>
      {errors.map(({ error, invalidItems }) => {
        const invalidItemsText = invalidItems.join('\n');

        return (
          <StyledErrorsContainerDiv key={error} data-test="bulk-invalid-items">
            <StyledErrorTitleTypography variant="caption" data-test="bulk-error">
              {error}
            </StyledErrorTitleTypography>
            <StyledInvalidItemsTypography variant="body1" component="pre">
              {invalidItemsText}
            </StyledInvalidItemsTypography>
            <Button type="button" onClick={() => copyToClipboardWithConfirmation(invalidItemsText, enqueueSnackbar, t)}>
              {t('Copy to Clipboard')}
            </Button>
          </StyledErrorsContainerDiv>
        );
      })}
    </>
  );
}
